import { branch, compose, renderNothing, withProps, withState } from 'recompose'
import { connect } from 'react-redux'
import { selectCurrentLoans } from 'src/store/selectors/home/loans'
import { selectHomeData } from 'src/store/selectors/home'
import {
  selectConventionalPMI,
  selectEstimatedPMI
} from 'src/store/selectors/home/pmi'
import { updateHomeLoan } from 'src/actions/home'

const EstimateAdjusterContainer = compose(
  withState('pmi', 'setPmi', ''),
  withState('loading', 'setLoading', null),
  connect(
    state => ({
      home: selectHomeData(state),
      manualPmi: selectConventionalPMI(state),
      estimatedPmi: selectEstimatedPMI(state),
      loan: selectCurrentLoans(state)[0]
    }),
    dispatch => ({
      updateLoan: data => dispatch(updateHomeLoan(data))
    })
  ),
  withProps(
    ({ pmi, setPmi, setLoading, estimatedPmi, updateLoan, home, loan }) => {
      const updatePmi = val =>
        updateLoan({
          pmiMonthly: val,
          id: loan.id,
          homeId: home.id
        })

      return {
        onSubmit: e => {
          e.preventDefault()
          setLoading('manual')
          updatePmi(pmi)
        },
        onNone: e => {
          e.preventDefault()
          setLoading('manual')
          updatePmi(0)
        },
        onConfirm: () => {
          setLoading('confirm')
          updatePmi(estimatedPmi)
        },
        onChange: e => {
          e.preventDefault()
          setPmi(e.target.value)
        }
      }
    }
  ),
  branch(({ manualPmi }) => manualPmi, renderNothing)
)

export default EstimateAdjusterContainer
